





















import { defineComponent } from '@vue/composition-api';
import Tab from '../../../components/TabScopedSlot.vue';
import SpeedContent from '../../../components/Content.vue';
import CommonContent from '../../../components/CommonContent.vue';
import ContractItem from '../../../components/ContractItem.vue';

export default defineComponent({
  name: 'ZhenXiangCard',
  props: {
    showSpeed: {
      type: Boolean,
      default: true,
      required: false,
    },
    checkStatus: {
      type: Boolean,
      default: false,
      required: false,
    },
    normalTextList: {
      type: Array,
      default: () => [],
      required: true,
    },
  },
  components: {
    Tab,
    SpeedContent,
    CommonContent,
    ContractItem,
  },
  emits: ['tab-click', 'check-status-change'],
  setup(props, { emit }) {
    const handleTabClick = (index: number) => {
      emit('tab-click', index);
    };

    const handleCheckStatusChange = (status: boolean) => {
      emit('check-status-change', status);
    };

    return {
      handleTabClick,
      handleCheckStatusChange,
    };
  },
});
